import { combineReducers } from "redux";
import LayoutReducer from "./layouts/reducer";
import fuarReducer from "./fuarSlice";
import standReducer from "./standSlice";
import fuarAlaniReducer from "./fuarAlaniSlice";

// firmaSlice (and its dead mock module firmaService.js's list/detail/create/assign/delete-
// assignment path) removed backlog #33, 2026-09-16 — its only consumers were the unrouted
// FirmaListPage.jsx/FirmaFormModal.jsx, gone since the 2026-09-12 Kartlar/Detay rework.
const rootReducer = combineReducers({
    Layout: LayoutReducer,
    fuar: fuarReducer,
    stand: standReducer,
    fuarAlani: fuarAlaniReducer,
});

export default rootReducer;